import axios from "axios";
import http from "@/api/http/http";

export default {
  list() {
    return axios.get(`${process.env.VUE_APP_API}/admin/staff`, http.setHeaders())
  },
  menus() {
    return axios.get(`${process.env.VUE_APP_API}/admin/staff/menus`, http.setHeaders())
  },
  myMenus() {
    return axios.get(`${process.env.VUE_APP_API}/admin/staff/me/menus`, http.setHeaders())
  },
  create(params) {
    return axios.post(`${process.env.VUE_APP_API}/admin/staff`, params, http.setHeaders())
  },
  update(id, params) {
    return axios.put(`${process.env.VUE_APP_API}/admin/staff/${id}`, params, http.setHeaders())
  },
  changePassword(id, password) {
    return axios.patch(`${process.env.VUE_APP_API}/admin/staff/${id}/password`, {password}, http.setHeaders())
  },
  delete(id) {
    return axios.delete(`${process.env.VUE_APP_API}/admin/staff/${id}`, http.setHeaders())
  },
}
